<template>
    <BreadCrumb PageTitle="Détail du recensement" />
    <ViewRecensement />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ViewRecensement from "@/components/Recensements/ViewRecensement.vue";

export default defineComponent({
    name: "ViewRecensementPage",
    components: {
        BreadCrumb,
        ViewRecensement,
    },
});
</script>
